module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e8cbf6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/NavBar.vue
// module id = 1404
// module chunks = 28